import { forwardRef } from 'react';
import { IconButton } from '../Button/IconButton/IconButton';
import type { IconButtonWrapperProps } from '../Button/IconButton/styles';
import { ButtonVariants } from '../Button/styles';
import { FormControlSizes } from '../Form/types';
import { IconName } from '../Icons/IconNames';
import { Tooltip } from '../Tooltip';

export const ExpandAllButton = forwardRef<HTMLButtonElement, IconButtonWrapperProps>((props, ref) => (
  <Tooltip tooltip="Expand All">
    <IconButton
      icon={IconName.ListExpand}
      size={FormControlSizes.Small}
      variant={ButtonVariants.Default}
      aria-label="Expand All"
      {...props}
      ref={ref}
    />
  </Tooltip>
));

ExpandAllButton.displayName = 'ExpandAllButton';

export const CollapseAllButton = forwardRef<HTMLButtonElement, IconButtonWrapperProps>((props, ref) => (
  <Tooltip tooltip="Collapse All">
    <IconButton
      icon={IconName.ListCollapse}
      size={FormControlSizes.Small}
      variant={ButtonVariants.Default}
      aria-label="Collapse All"
      {...props}
      ref={ref}
    />
  </Tooltip>
));

CollapseAllButton.displayName = 'CollapseAllButton';
